export const hasCollaboratorId = (collaborators, collaboratorId) =>
  collaborators.some(({ id }) => id === collaboratorId);

const removeCollaboratorById = (collaborators, collaboratorId) =>
  collaborators.filter(({ id }) => id !== collaboratorId);

export const isValidCollaborator = collaborator =>
  Boolean(collaborator) && collaborator.id !== undefined && collaborator.id !== null;

export const getStateAfterSelect = (state, collaborator) => {
  if (!isValidCollaborator(collaborator)) return state;

  const { id } = collaborator;
  const isInitialCollaborator = hasCollaboratorId(state.collabs, id);
  const isPendingAdd = hasCollaboratorId(state.collabsToAdd, id);
  const isPendingRemove = hasCollaboratorId(state.collabsToRemove, id);

  if (isInitialCollaborator && isPendingRemove) {
    return {
      ...state,
      collabsToRemove: removeCollaboratorById(state.collabsToRemove, id)
    };
  }

  if (!isInitialCollaborator && !isPendingAdd) {
    return {
      ...state,
      collabsToAdd: [...state.collabsToAdd, collaborator]
    };
  }

  return state;
};

export const getStateAfterRemove = (state, collaborator) => {
  if (!isValidCollaborator(collaborator)) return state;

  const { id } = collaborator;
  const isInitialCollaborator = hasCollaboratorId(state.collabs, id);
  const isPendingRemove = hasCollaboratorId(state.collabsToRemove, id);

  return {
    ...state,
    collabsToAdd: removeCollaboratorById(state.collabsToAdd, id),
    collabsToRemove:
      isInitialCollaborator && !isPendingRemove
        ? [...state.collabsToRemove, collaborator]
        : state.collabsToRemove
  };
};
